import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";

export const ButtonPrintF4 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

const cellStyle = {
  border: "1px solid black",
  padding: "4px",
  height: "14px",
  textAlign: "center",
  verticalAlign: "top",
  wordWrap: "break-word",
};

export const PrintDocF4 = ({ innerRef, item, type }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  const handleValidDate = (date) => {
    return moment(date).format("D MMMM YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  // const svgElement = document.querySelector("#qrcode-container svg");
  // const svgString = new XMLSerializer().serializeToString(svgElement);
  // const base64Svg = `data:image/svg+xml;base64,${btoa(svgString)}`;

  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      // className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      {/* ///1/// */}
      {type === "surat-permohonan" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            SURAT KUASA PERMOHONAN PENGUKURAN
          </div>
          <div style={{ padding: "10px" }}>
            <span>Yang bertanda tangan di bawah ini, kami :</span>
            <table style={{ marginLeft: "40px", marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_pemohon)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_pemohon)}</td>
                </tr>
                <tr>
                  <td>KTP No.</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_pemohon)}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginLeft: "40px" }}>Selanjutnya disebut Pihak I (kesatu)</div>

            <table style={{ marginLeft: "40px", marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_kuasa)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_kuasa)}</td>
                </tr>
                <tr>
                  <td>KTP No.</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_kuasa)} (Fotocopy terlampir)</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginLeft: "40px" }}>Selanjutnya disebut Pihak II (kedua)</div>

            <div style={{ marginTop: "5px" }}>
              <ol style={{ paddingLeft: "20px", lineHeight: "1.5" }}>
                <li>
                  Pihak I adalah pemilik sebidang tanah yang terletak di :
                  <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "120px" }}>Jalan / Blok</td>
                        <td style={{ width: "15px" }}>:</td>
                        <td>{validValue(item?.jalan)}</td>
                      </tr>
                      <tr>
                        <td>RT / RW</td>
                        <td>:</td>
                        <td>
                          {validValue(item?.rt)} / {validValue(item?.rw)}
                        </td>
                      </tr>
                      <tr>
                        <td>Kelurahan / Desa</td>
                        <td>:</td>
                        <td>{validValue(item?.desa)}</td>
                      </tr>
                      <tr>
                        <td>Kecamatan</td>
                        <td>:</td>
                        <td>{validValue(item?.kecamatan)}</td>
                      </tr>
                      <tr>
                        <td>Kabupaten</td>
                        <td>:</td>
                        <td>{validValue(item?.kabupaten)}</td>
                      </tr>
                      <tr>
                        <td>Status Tanah</td>
                        <td>:</td>
                        <td>{validValue(item?.status_tanah)}</td>
                      </tr>
                      <tr>
                        <td>Luas</td>
                        <td>:</td>
                        <td>{validValue(item?.luas)} m²</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li>
                  Pihak I dengan ini memberi kuasa kepada Pihak II untuk mengurus permohonan pengukuran atas tanah tersebut di atas pada Kantor Pertanahan Kabupaten Bogor, kuasa ini meliputi :
                  <ul style={{ marginLeft: "-30px", listStyleType: "none" }}>
                    <li>- Menandatangani permohonan pengukuran</li>
                    <li>- Menunjukan batas-batas tanah tersebut</li>
                  </ul>
                </li>
                <li>Pihak II bertanggung jawab sepenuhnya apabila dikemudian hari diketahui adanya kekeliruan penunjukan batas tersebut.</li>
              </ol>
            </div>

            <div style={{ marginLeft: "20px", marginTop: "-10px" }}>Demikian Surat Kuasa ini dibuat dengan sebenarnya.</div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "40px",
              }}
            >
              <div>Bogor, {validValue(item?.tanggal)}</div>
            </div>

            <div
              style={{
                marginTop: "40px",
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <div>
                <div>Pihak II</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_kuasa)}</div>
              </div>
              <div>
                <div>Pihak I</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
                {/* <div style={{ marginTop: "10px", fontSize: "11px" }}>Materai Rp. 6000,-</div> */}
              </div>
            </div>
          </div>
          {/* //// */}
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            {/* Judul */}
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              SURAT PERNYATAAN
            </div>

            {/* Isi surat */}
            <div style={{ padding: "10px" }}>
              <span>Yang bertanda tangan di bawah ini, kami :</span>

              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "120px" }}>Nama</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.nama_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Alamat</td>
                    <td>:</td>
                    <td>{validValue(item?.alamat_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Pekerjaan</td>
                    <td>:</td>
                    <td>{validValue(item?.pekerjaan_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Identitas</td>
                    <td>:</td>
                    <td>{validValue(item?.ktp_pemohon)}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: "10px" }}>Selaku pemohon pengukuran dan pemilik tanah yang terletak di :</div>

              <table style={{ marginTop: "5px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "120px" }}>Jalan / Blok</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.blok)}</td>
                  </tr>
                  <tr>
                    <td>Kelurahan / Desa</td>
                    <td>:</td>
                    <td>{validValue(item?.desa)}</td>
                  </tr>
                  <tr>
                    <td>Kecamatan</td>
                    <td>:</td>
                    <td>{validValue(item?.kecamatan)}</td>
                  </tr>
                  <tr>
                    <td>Kabupaten</td>
                    <td>:</td>
                    <td>{validValue(item?.kabupaten)}</td>
                  </tr>
                  <tr>
                    <td>Seluas</td>
                    <td>:</td>
                    <td>{validValue(item?.luas)}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: "15px" }}>Menyatakan bahwa :</div>

              <ol style={{ paddingLeft: "10px", lineHeight: "1", marginTop: "5px" }}>
                <li>Atas bidang tanah tersebut telah mengetahui letaknya dan telah dipasang tanda-tanda batasnya sebanyak {validValue(item?.jumlah_batasan)} buah dan memperoleh persetujuan dari pemilik tanah yang bersangkutan.</li>
                <li>Tanda-tanda batas tersebut dari beton / besi dan kami pelihara dengan sebaik-baiknya.</li>
                <li>Atas bidang tanah tersebut sampai saat ini belum pernah dijadikan jaminan hutang atau diperjualbelikan dan tidak dalam keadaan sengketa.</li>
              </ol>

              <div style={{ marginTop: "15px" }}>Demikianlah pernyataan ini dibuat untuk keperluan permohonan pengukuran kepala Kantor Pertanahan Kabupaten Bogor.</div>

              {/* TANDA TANGAN */}
              <div style={{ marginTop: "40px", textAlign: "right" }}>
                <div>Bogor, {validValue(item?.tanggal)}</div>
                <div style={{ marginTop: "60px" }}>Yang Membuat Pernyataan</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
                {/* <div style={{ marginTop: "10px", fontSize: "11px" }}>Materai Rp. 6.000,-</div> */}
              </div>
            </div>
          </div>
          {/* //// */}
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              SURAT PERNYATAAN
            </div>
            <div style={{ padding: "10px" }}>
              <span>Yang bertanda tangan di bawah ini :</span>

              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.nama_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Alamat</td>
                    <td>:</td>
                    <td>{validValue(item?.alamat_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Pekerjaan</td>
                    <td>:</td>
                    <td>{validValue(item?.pekerjaan_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Identitas (KTP)</td>
                    <td>:</td>
                    <td>{validValue(item?.ktp_pemohon)}</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: "10px" }}>Selaku pemohon pengukuran dan pemilik tanah yang terletak di :</div>

              <table style={{ marginTop: "5px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "120px" }}>Jalan / Blok</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.jalan)}</td>
                  </tr>
                  <tr>
                    <td>Kelurahan / Desa</td>
                    <td>:</td>
                    <td>{validValue(item?.desa)}</td>
                  </tr>
                  <tr>
                    <td>Kecamatan</td>
                    <td>:</td>
                    <td>{validValue(item?.kecamatan)}</td>
                  </tr>
                  <tr>
                    <td>Kabupaten</td>
                    <td>:</td>
                    <td>{validValue(item?.kabupaten)}</td>
                  </tr>
                  <tr>
                    <td>Luas</td>
                    <td>:</td>
                    <td>{validValue(item?.luas)} m²</td>
                  </tr>
                </tbody>
              </table>

              <div style={{ marginTop: "15px" }}>Menyatakan bahwa :</div>

              <ol style={{ paddingLeft: "20px", lineHeight: "1", marginTop: "5px" }}>
                <li>Di atas bidang tanah tersebut harga pasaran jual beli per meter Rp {validValue(item?.harga_tanah_pasaran)}.</li>
                <li>Harga tanah berdasarkan SPPT / NJOP Tahun {validValue(item?.harga_tanah_sppt)} per meter.</li>
              </ol>

              <div style={{ marginTop: "15px" }}>Demikian pernyataan ini dibuat untuk keperluan permohonan pengukuran kepada Kantor Pertanahan Kabupaten Bogor.</div>

              {/* TANDA TANGAN */}
              <div
                style={{
                  marginTop: "40px",
                  textAlign: "right",
                }}
              >
                <div>Bogor, {validValue(item?.tanggal)}</div>
                <div style={{ marginTop: "60px" }}>Yang Membuat Pernyataan</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
              </div>
            </div>
          </div>

          {/* //// */}
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ marginTop: "10px" }}>
                <div>Nomor : </div>
                <div>Lampiran : </div>
                <div>
                  {`Perihal : Permohonan `}
                  {validValue(item?.s)}
                </div>
              </div>
              <div style={{ marginTop: "10px" }}>
                <div>Kepada Yth. :</div>
                <div>Sdr. Kepala Kantor Pertanahan</div>
                <div>
                  {`Kabupaten / Kota `}
                  {validValue(item?.s)}
                </div>
                <div>
                  {`di `}
                  {validValue(item?.s)}
                </div>
              </div>
            </div>

            <div style={{ marginTop: "15px", marginBottom: "15px" }}>Dengan Hormat,</div>
            <div>Yang Bertanda tangan di bawah ini :</div>

            <table style={{ marginLeft: "40px", marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_pemohon)}</td>
                </tr>
                <tr>
                  <td>Umur</td>
                  <td>:</td>
                  <td>{validValue(item?.umur_pemohon)}</td>
                </tr>
                <tr>
                  <td>Pekerjaan</td>
                  <td>:</td>
                  <td>{validValue(item?.pekerjaan_pemohon)}</td>
                </tr>
                <tr>
                  <td>Nomor KTP</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_pemohon)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_pemohon)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "10px" }}>Dalam hal ini bertindak untuk dan atas nama diri sendiri / selaku kuasa dari :</div>

            <table style={{ marginLeft: "40px", marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_kuasa)}</td>
                </tr>
                <tr>
                  <td>Umur</td>
                  <td>:</td>
                  <td>{validValue(item?.umur_kuasa)}</td>
                </tr>
                <tr>
                  <td>Pekerjaan</td>
                  <td>:</td>
                  <td>{validValue(item?.pekerjaan_kuasa)}</td>
                </tr>
                <tr>
                  <td>Nomor KTP</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_kuasa)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_kuasa)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "10px" }}>
              Berdasarkan surat kuasa Nomor <span>{validValue(item?.s)}</span> tanggal <span>{validValue(item?.s)}</span> dengan ini mengajukan permohonan :
            </div>

            <div style={{ display: "flex", gap: "40px", marginTop: "5px" }}>
              <ol style={{ paddingLeft: "50px", lineHeight: "1.5" }}>
                {["Pengukuran", "Konversi / Pendaftaran Hak", "Pendaftaran Hak Milik Sarusun", "Pendaftaran Tanah Wakaf", "Pendaftaran Peralihan Hak", "Pendaftaran Pemindahan Hak", "Pendaftaran Perubahan Hak", "Pemecahan / Penggabungan Hak", "Pendaftaran Hak Tanggungan", "Roya Atas Hak Tanggungan", "Penerbitan Sertifikat Pengganti", "Surat Keterangan Pendaftaran Tanah", "Pengecekan Sertifikat", "Pencatatan", "Zona Nilai Tanah (ZNT)"].slice(0, 7).map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ol>

              <ol style={{ lineHeight: "1.5" }}>
                {["Pengukuran", "Konversi / Pendaftaran Hak", "Pendaftaran Hak Milik Sarusun", "Pendaftaran Tanah Wakaf", "Pendaftaran Peralihan Hak", "Pendaftaran Pemindahan Hak", "Pendaftaran Perubahan Hak", "Pemecahan / Penggabungan Hak", "Pendaftaran Hak Tanggungan", "Roya Atas Hak Tanggungan", "Penerbitan Sertifikat Pengganti", "Surat Keterangan Pendaftaran Tanah", "Pengecekan Sertifikat", "Pencatatan", "Zona Nilai Tanah (ZNT)"].slice(7).map((item, idx) => (
                  <li key={idx + 7}>{item}</li>
                ))}
              </ol>
            </div>

            <div style={{ marginTop: "10px" }}>Atas bidang tanah hak / tanah negara :</div>

            <table style={{ marginLeft: "40px", marginTop: "5px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Terletak di</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.terletak)}</td>
                </tr>
                <tr>
                  <td>Desa / Kelurahan</td>
                  <td>:</td>
                  <td>{validValue(item?.desa)}</td>
                </tr>
                <tr>
                  <td>Kecamatan</td>
                  <td>:</td>
                  <td>{validValue(item?.kecamatan)}</td>
                </tr>
                <tr>
                  <td>Kabupaten / Kotamadya</td>
                  <td>:</td>
                  <td>{validValue(item?.kabupaten)}</td>
                </tr>
                <tr>
                  <td>Nomor Hak</td>
                  <td>:</td>
                  <td>{validValue(item?.nomorHak)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "10px" }}>Untuk melengkapi permohonan dimaksud, bersama ini kami lampirkan :</div>

            <ol style={{ marginLeft: "20px", marginTop: "5px" }}>
              <li>{validValue("FC ALAS SURAT")}</li>
              <li>{validValue("FC KTP PEMOHON DAN FC KTP KUASA")}</li>
              <li>{validValue(item?.lampiran?.[2])}</li>
              <li>{validValue(item?.lampiran?.[3])}</li>
            </ol>

            <div style={{ marginTop: "40px", textAlign: "right" }}>
              <div>Hormat Kami,</div>
              <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
            </div>
          </div>
        </div>
      )}

      {/* 2 */}
      {type === "surat-pernyataan" && (
        // <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px", fontSize: "12px" }}>
        //   {/* Judul */}
        //   <div
        //     style={{
        //       textAlign: "center",
        //       padding: "5px 0",
        //       textDecoration: "underline",
        //       fontSize: "18px",
        //       fontWeight: "bold",
        //     }}
        //   >
        //     SURAT PERNYATAAN
        //   </div>

        //   {/* Isi surat */}
        //   <div style={{ padding: "10px" }}>
        //     <span>Yang bertanda tangan di bawah ini, kami :</span>

        //     <table style={{ marginLeft: "40px", marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
        //       <tbody>
        //         <tr>
        //           <td style={{ width: "120px" }}>Nama</td>
        //           <td style={{ width: "15px" }}>:</td>
        //           <td>{validValue(item?.nama_pemohon)}</td>
        //         </tr>
        //         <tr>
        //           <td>Alamat</td>
        //           <td>:</td>
        //           <td>{validValue(item?.alamat_pemohon)}</td>
        //         </tr>
        //         <tr>
        //           <td>Pekerjaan</td>
        //           <td>:</td>
        //           <td>{validValue(item?.pekerjaan_pemohon)}</td>
        //         </tr>
        //         <tr>
        //           <td>Identitas</td>
        //           <td>:</td>
        //           <td>{validValue(item?.ktp_pemohon)}</td>
        //         </tr>
        //       </tbody>
        //     </table>

        //     <div style={{ marginTop: "10px" }}>Selaku pemohon pengukuran dan pemilik tanah yang terletak di :</div>

        //     <table style={{ marginLeft: "40px", marginTop: "5px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
        //       <tbody>
        //         <tr>
        //           <td style={{ width: "120px" }}>Jalan / Blok</td>
        //           <td style={{ width: "15px" }}>:</td>
        //           <td>{validValue(item?.blok)}</td>
        //         </tr>
        //         <tr>
        //           <td>Kelurahan / Desa</td>
        //           <td>:</td>
        //           <td>{validValue(item?.desa)}</td>
        //         </tr>
        //         <tr>
        //           <td>Kecamatan</td>
        //           <td>:</td>
        //           <td>{validValue(item?.kecamatan)}</td>
        //         </tr>
        //         <tr>
        //           <td>Kabupaten</td>
        //           <td>:</td>
        //           <td>{validValue(item?.kabupaten)}</td>
        //         </tr>
        //         <tr>
        //           <td>Seluas</td>
        //           <td>:</td>
        //           <td>{validValue(item?.luas)}</td>
        //         </tr>
        //       </tbody>
        //     </table>

        //     <div style={{ marginTop: "15px" }}>Menyatakan bahwa :</div>

        //     <ol style={{ paddingLeft: "20px", lineHeight: "1", marginTop: "5px" }}>
        //       <li>Atas bidang tanah tersebut telah mengetahui letaknya dan telah dipasang tanda-tanda batasnya sebanyak {validValue(item?.sebanyak)} buah dan memperoleh persetujuan dari pemilik tanah yang bersangkutan.</li>
        //       <li>Tanda-tanda batas tersebut dari beton / besi dan kami pelihara dengan sebaik-baiknya.</li>
        //       <li>Atas bidang tanah tersebut sampai saat ini belum pernah dijadikan jaminan hutang atau diperjualbelikan dan tidak dalam keadaan sengketa.</li>
        //     </ol>

        //     <div style={{ marginTop: "15px" }}>Demikianlah pernyataan ini dibuat untuk keperluan permohonan pengukuran kepala Kantor Pertanahan Kabupaten Bogor.</div>

        //     {/* TANDA TANGAN */}
        //     <div style={{ marginTop: "40px", textAlign: "right" }}>
        //       <div>Bogor, {validValue(item?.tanggal)}</div>
        //       <div style={{ marginTop: "60px" }}>Yang Membuat Pernyataan</div>
        //       <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
        //       {/* <div style={{ marginTop: "10px", fontSize: "11px" }}>Materai Rp. 6.000,-</div> */}
        //     </div>
        //   </div>
        // </div>
        <></>
      )}

      {/* 3 */}
      {type === "surat-pernyataan-batas" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
              textDecoration: "underline",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            <div>SURAT PERNYATAAN</div>
            <div>PEMASANGAN TANDA BATAS DAN PERSETUJUAN PEMILIK YANG BERBATASAN</div>
          </div>
          <div style={{ padding: "10px" }}>
            <span>Yang bertanda tangan di bawah ini :</span>

            <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_pemohon)}</td>
                </tr>
                <tr>
                  <td>Umur</td>
                  <td>:</td>
                  <td>{validValue(item?.umur_pemohon)}</td>
                </tr>
                <tr>
                  <td>NIK</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_pemohon)}</td>
                </tr>
                <tr>
                  <td>Pekerjaan</td>
                  <td>:</td>
                  <td>{validValue(item?.pekerjaan_pemohon)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top" }}>Alamat</td>
                  <td style={{ verticalAlign: "top" }}>:</td>
                  <td>{validValue(item?.alamat_pemohon)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "15px" }}>
              Adalah Pemilik Tanah Kohir No. <span>{validValue(item?.nomor)}</span> Persil <span>{validValue(item?.persil)}</span> Kelas <span>{validValue(item?.kelas)}</span> Seluas ± <span>{validValue(item?.luas)}</span> M² yang terletak di Blok <span>{validValue(item?.blok)}</span> Desa/Kelurahan <span>{validValue(item?.desa)}</span> Kecamatan <span>{validValue(item?.kecamatan)}</span> Kabupaten Bogor berdasarkan <span>{validValue(item?.berdasarkan)}</span>
            </div>

            <div style={{ marginTop: "15px" }}>Dengan ini menyatakan bahwa tanah tersebut :</div>

            <ol style={{ paddingLeft: "15px", lineHeight: "1", marginTop: "5px" }}>
              <li>Telah dipasang patok/tanda batas;</li>
              <li>Terhadap patok yang yang dipasang tersebut tidak ada pihak yang berkeberatan;</li>
              <li>Apabila ternyata luas hasil ukur lebih kecil dari luas yang tertulis pada alas hak/akta peralihan hak/surat-surat lain dalam berkas permohonan sertipikat, kami menerima luas hasil ukuran petugas Kantor Pertanahan; dan</li>
              <li>Apabila luas hasil pengukuran ternyata lebih besar dari yang tertulis pada alas hak/akta peralihan hak/surat-surat lain dalam berkas permohonan sertipikat, saya tidak mengambil hak orang lain dan tidak ada perolehan lain selain bukti pemilikan tersebut di atas, apabila ada gugatan/keberatan dari pihak lain, saya akan bertanggung jawab.</li>
            </ol>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div style={{ marginTop: "15px" }}>Demikian Surat Pernyataan ini saya buat dengan sebenarnya dengan penuh tanggung jawab dan saya siap mengangkat sumpah bila diperlukan, apabila pernyataan ini tidak benar saya bersedia dituntut di hadapan pihak yang berwenang.</div>

            {/* TANDA TANGAN */}
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
                marginTop: "40px",
              }}
            >
              <div>
                <div>Menyetujui pemilik yang berbatasan:</div>
                <div style={{ textAlign: "start" }}>
                  <div>Sebelah utara:</div>
                  <div>{validValue(item?.utara)}</div>
                  <div>({validValue(item?.utara)})</div>
                </div>
                <div style={{ textAlign: "start" }}>
                  <div>Sebelah timur:</div>
                  <div>{validValue(item?.timur)}</div>
                  <div>({validValue(item?.timur)})</div>
                </div>
                <div style={{ textAlign: "start" }}>
                  <div>Sebelah selatan:</div>
                  <div>{validValue(item?.selatan)}</div>
                  <div>({validValue(item?.selatan)})</div>
                </div>
                <div style={{ textAlign: "start" }}>
                  <div>Sebelah barat:</div>
                  <div>{validValue(item?.barat)}</div>
                  <div>({validValue(item?.barat)})</div>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div>Bogor, {validValue(item?.tanggal)}</div>
                <div>Yang Membuat Pernyataan</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
              </div>
            </div>
            <div>*Melampirkan fotocopi KTP para pihak yang bersebelahan/berbatasan atau diketahui oleh Kepala Desa/Lurah.</div>
            <div style={{ marginTop: "15px" }}>SKETSA BIDANG TANAH</div>
            <div>Informasi Sketsa:</div>
            <ol style={{ paddingLeft: "15px", lineHeight: "1", marginTop: "5px" }}>
              <li>Harus ada alamat jelas;</li>
              <li>Gambar lokasi tetangga batas;</li>
              <li>Lokasi relatif dari tempat umum (contoh: Masjid, SPBU, dan lain-lain) atau unsur geografis (jalan, sungai, jembatan).</li>
            </ol>
            <div style={{ border: "1px solid black", padding: "5px", height: "200px", width: "100%" }}>
              <span>Kolom Gambar Sketsa Bidang:</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "end",
                marginTop: "40px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div>Mengetahui</div>
                <div>Kepala Desa/Lurah</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.kepala_desa)}</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type === "surat-pernyataan-fisik-bidang-tanah" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
              textDecoration: "underline",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            <div>SURAT PERNYATAAN PENGUASAAN FISIK BIDANG TANAH</div>
          </div>
          <div style={{ padding: "10px" }}>
            <span>Yang bertanda tangan di bawah ini :</span>

            <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_pemohon)}</td>
                </tr>
                <tr>
                  <td>NIK</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_pemohon)}</td>
                </tr>
                <tr>
                  <td>Agama</td>
                  <td>:</td>
                  <td>{validValue(item?.agama_pemohon)}</td>
                </tr>
                <tr>
                  <td>Umur</td>
                  <td>:</td>
                  <td>{validValue(item?.umur_pemohon)}</td>
                </tr>
                <tr>
                  <td>Pekerjaan</td>
                  <td>:</td>
                  <td>{validValue(item?.pekerjaan_pemohon)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top" }}>Alamat</td>
                  <td style={{ verticalAlign: "top" }}>:</td>
                  <td>{validValue(item?.alamat_pemohon)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "15px" }}>Dengan ini menyatakan dengan sesungguhnya serta dengan itikad baik bahwa Saya menguasai/memiliki sebidak tanah yang terletak di:</div>
            <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "120px" }}>Jalan, RT/RW</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>
                    <span>{validValue(item?.jalan)}</span>,{" "}
                    <span>
                      {validValue(item?.rt)}/{validValue(item?.rw)}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Desa/Kelurahan</td>
                  <td>:</td>
                  <td>{validValue(item?.desa)}</td>
                </tr>
                <tr>
                  <td>Kecamatan</td>
                  <td>:</td>
                  <td>{validValue(item?.kecamatan)}</td>
                </tr>
                <tr>
                  <td>Kabupaten/Kota</td>
                  <td>:</td>
                  <td>{validValue(item?.kabupaten)}</td>
                </tr>
                <tr>
                  <td>NIB</td>
                  <td>:</td>
                  <td>{validValue(item?.nib)}</td>
                </tr>
                <tr>
                  <td>Status Tanah</td>
                  <td>:</td>
                  <td>{validValue(item?.status_tanah)}</td>
                </tr>
                <tr>
                  <td>Dipergunakan untuk</td>
                  <td>:</td>
                  <td>{validValue(item?.digunakan_tanah)}</td>
                </tr>
                <tr>
                  <td>Batas-batas tanah</td>
                  <td>:</td>
                  <td>{validValue(item?.batas_batas_tanah)}</td>
                </tr>
                <tr>
                  <td>Utara</td>
                  <td>:</td>
                  <td>{validValue(item?.utara)}</td>
                </tr>
                <tr>
                  <td>Timur</td>
                  <td>:</td>
                  <td>{validValue(item?.timur)}</td>
                </tr>
                <tr>
                  <td>Selatan</td>
                  <td>:</td>
                  <td>{validValue(item?.selatan)}</td>
                </tr>
                <tr>
                  <td>Barat</td>
                  <td>:</td>
                  <td>{validValue(item?.barat)}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: "15px" }}>
              <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
                <li>Bidang tanah tersebut adalah benar milik Saya bukan milik orang lain dan statusnya adalah Tanah Negara/Tanah Ulayat/ ... *;</li>
                <li>Bidang tanah tersebut Saya kuasai secara fisik sejak tahun {validValue(item?.tahun_fisik)} yang sampai saat ini Saya kuasai secara terus menerus;</li>
                <li>
                  Bidang tanah tersebut Saya peroleh dari {validValue(item?.diperoleh_dari)} sejak tahun {validValue(item?.tahun)};
                </li>
                <li>Penguasaan bidang tanah tersebut dengan iktikad baik dan secara terbuka oleh Saya sebagai yang berhak atas bidang tanah tersebut;</li>
                <li>Perolehan tanah dibuat sesuai data yang sebenarnya dan apabila ternyata di kemudian hari terjadi permasalahan menjadi tanggung jawab pemohon sepenuhnya dan tidak akan melibatkan Kementerian;</li>
                <li>Bidang tanah tersebut tidak terdapat konflik/sengketa/perkara dan keberatan dari pihak lain atas tanah yang dimiliki atau tidak dalam keadaan sengketa;</li>
                <li>
                  Bidang tanah tersebut tidak dijadikan/menjadi jaminan sesuatu utang/ tidak terdapat keberatan dari pihak Kreditur <i>(apabila dijadikan/menjadi jaminan sesuatu utang)</i> *);
                </li>
                <li>
                  Bidang tanah tersebut bukan asset *):
                  <div>
                    <ol type="a" style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
                      <li>pemerintah/Pemerintah Daerah/Badan Usaha Milik Negara/Badan Usaha Milik Daerah; atau</li>
                      <li>pemerintah/pemerintah daerah/Badan Usaha Milik Negara/Badan Usaha Milik Daerah lain; untuk permohonan Hak Pengelolaan atau Hak Pakai selama dipergunakan yang dimohon oleh instansi pemerintah.</li>
                    </ol>
                  </div>
                </li>
                <li>Bidang tanah tersebut berada di luar kawasan hutan, di luar areal yang dihentikan perizinannya pada hutan alam primer dan lahan gambut;</li>
                <li>Bersedia untuk tidak mengurung atau menutup pekarangan atau bidang tanah lain dari lalu lintas umum, akses publik dan/atau jalan</li>
                <li>Bersedia melepaskan tanah untuk kepentingan umum baik sebagian atau seluruhnya.</li>
              </ol>
            </div>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div style={{ marginTop: "15px" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;Surat Pernyataan ini saya buat dengan sebenar-benarnya dengan penuh tanggung jawab baik secara perdata maupun pidana, apabila di kemudian hari terdapat unsur-unsur yang tidak dibenarkan dalam pernyataan ini maka segala akibat yang timbul menjadi tanggung jawab Saya dan bersedia dituntut sesuai dengan ketentuan peraturan perundang-undangan serta tidak akan melibatkan pihak lain dan Saya bersedia sertipikat yang Saya terima dibatalkan oleh pejabat yang
              berwenang.
            </div>

            <div style={{ marginTop: "15px" }}>
              <div>Demikian surat pernyataan ini dibuat dengan disaksikan oleh:</div>
              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "20px" }}>1.</td>
                    <td style={{ width: "80px" }}>Nama</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.nama_saksi1)}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.umur_saksi1 ? item?.umur_saksi1 + " TAHUN" : "......... TAHUN")}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.pekerjaan_saksi1)}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.alamat_saksi1)}</td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "20px" }}>2.</td>
                    <td style={{ width: "80px" }}>Nama</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.nama_saksi2)}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Umur</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.umur_saksi2 ? item?.umur_saksi2 + " TAHUN" : "......... TAHUN")}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Pekerjaan</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.pekerjaan_saksi2)}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "20px" }}></td>
                    <td>Alamat</td>
                    <td style={{ width: "20px" }}>:</td>
                    <td>{validValue(item?.alamat_saksi2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: "15px", display: "flex", justifyContent: "space-between" }}>
              <div>
                <div>Saksi-saksi:</div>
                <div
                  style={{
                    height: "100px",
                  }}
                >
                  1.
                </div>
                <div
                  style={{
                    height: "100px",
                  }}
                >
                  2.
                </div>
              </div>
              <div>
                <div style={{ textAlign: "center" }}>
                  <div>Bogor, {validValue(item?.tanggal)}</div>
                  <div>Yang Membuat Pernyataan</div>
                  <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama_pemohon)}</div>
                </div>
                <div style={{ textAlign: "center", marginTop: "15px" }}>
                  <div>Mengetahui</div>
                  <div>Kepala Desa/Lurah</div>
                  <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.kepala_desa)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type === "surat-tanda-terima-pengukuran" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
              textDecoration: "underline",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            <div>TANDA TERIMA BERKAS PERMOHONAN PENGUKURAN</div>
          </div>
          <div style={{ padding: "10px" }}>
            <span>Telah diterima berkas dari:</span>

            <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "180px" }}>Nama Pemohon</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama_pemohon)}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top" }}>Alamat</td>
                  <td style={{ verticalAlign: "top" }}>:</td>
                  <td>{validValue(item?.alamat_pemohon)}</td>
                </tr>
                <tr>
                  <td>Nomor Identitas (NIK)</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp_pemohon)}</td>
                </tr>
                <tr>
                  <td>Nomor Telepon (WhatsApp)</td>
                  <td>:</td>
                  <td>{validValue(item?.telpon_pemohon)}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td>{validValue(item?.email_pemohon)}</td>
                </tr>
                <tr style={{ fontWeight: "bold" }}>
                  <td>Jenis Permohonan</td>
                  <td>:</td>
                  <td>{validValue(item?.jenis_permohonan)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "15px", fontWeight: "bold" }}>Daftar Berkas yang Diterima</div>

            <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
              <li>Surat Permohonan Pengukuran</li>
              <li>Fotokopi Identitas Pemohon</li>
              <li>Print screen lokasi yang dimohon (share location)</li>
              <li>Foto batas permanen bidang tanah</li>
              <li>Surat Pernyataan Penutupan Berkas Permohonan dan Tidak Menuntut Pengembalian PNBP</li>
              <li>Surat Pernyataan Pemasan Tanda Batas dan Persetujuan Pemilik Yang Berbatasan</li>
              <li>................</li>
            </ol>
            <div style={{ marginTop: "15px", fontWeight: "bold" }}>Tanggal Penerimaan</div>
            <div style={{ marginTop: "15px", fontWeight: "bold" }}>Mekanisme pelaksanaan pengukuran</div>
            <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
              <li>Surat Perintah Setor (SPS) diterbitkan tanggal {validValue(item?.sps_tgl_terbit)}</li>
              <li>Tanggal pembayaran SPS maksimal tanggal {validValue(item?.sps_tgl_maksimal)}</li>
              <li>Pemohon menunggu di lokasi bidang tanah, pengukuran akan dilaksanakan pada tanggal {validValue(item?.tgl_pengukuran)} jam 09.00 sampai jam 12.00, pemohon dan para pihak yang berkepentingan mohon agar menunggu di lapangan.</li>
            </ol>

            <div style={{ marginTop: "15px" }}>Demikian tanda terima ini dibuat sebagai bukti bahwa berkas permohonan telah kami terima untuk diproses sesuai ketentuan yang berlaku.</div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
              <div style={{ textAlign: "center" }}>
                <div>Petugas Penerima</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>
                  <span className="courier-prime-bold text-capitalize">{`(...................)`}</span>
                </div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div>Pemohon</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>({validValue(item?.nama_pemohon)})</div>
              </div>
            </div>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            {/* === HEADER TABLE === */}
            <table
              border="1"
              cellPadding="6"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "5px",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ textAlign: "center", width: "150px", padding: "10px", border: "1px solid" }}>
                    <div style={{ fontWeight: "bold", fontSize: "14px" }}>Logo</div>
                  </td>
                  <td style={{ textAlign: "center", padding: "10px", border: "1px solid" }}>
                    <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                      KANTOR PERTANAHAN KABUPATEN
                      <br />
                      BOGOR II
                    </div>
                    <div>Jl. Jl. Alternatif Cibubur No.6, Cileungsi</div>
                  </td>
                  <td style={{ verticalAlign: "top", padding: "10px" }}>
                    <div style={{ textAlign: "center", fontWeight: "bold" }}>
                      <div>Berkas Permohonan Pengukuran</div>
                      <div>CM.WARKAH.</div>
                      <div>Rev.04</div>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "top", width: "120px" }}>Nama Pemohon</td>
                            <td style={{ width: "15px" }}>:</td>
                            <td>{validValue(item?.nama_pemohon)}</td>
                          </tr>
                          <tr>
                            <td>Kabupaten</td>
                            <td>:</td>
                            <td>{validValue(item?.kabupaten)}</td>
                          </tr>
                          <tr>
                            <td>Provinsi</td>
                            <td>:</td>
                            <td>{validValue(item?.propinsi)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            {/* === MAIN FORM TABLE === */}
            <table
              border="1"
              cellPadding="6"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "10px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid" }}>No</th>
                  <th style={{ width: "200px", border: "1px solid" }}>Kelengkapan Warkah</th>
                  <th style={{ border: "1px solid" }}>Ada</th>
                  <th style={{ border: "1px solid" }}>Tidak Ada</th>
                  <th style={{ border: "1px solid" }}>Soft Copy</th>
                  <th style={{ border: "1px solid" }}>Hardcopy</th>
                  <th style={{ border: "1px solid" }}>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    no: 1,
                    item: "Surat Permohonan Pengukuran",
                    note: "Wajib diisi secara lengkap dan sudah ditandatangani pemohon",
                  },
                  {
                    no: 2,
                    item: "Fotokopi Identitas Pemohon",
                    note: "NIK harus sesuai Dukcapil",
                  },
                  {
                    no: 3,
                    item: "Print screen lokasi yang dimohon (share location)",
                    note: <i>Link lokasi permohonan harus dapat diakses</i>,
                  },
                  {
                    no: 4,
                    item: "Foto batas permanen bidang tanah",
                    note: <i>Foto Patok harus unique</i>,
                  },
                  {
                    no: 5,
                    item: "Surat Pernyataan Penutupan Berkas Permohonan dan Tidak Menuntut Pengembalian PNBP",
                    note: "Wajib diisi secara lengkap dan sudah ditandatangani pemohon",
                  },
                  {
                    no: 6,
                    item: "Surat Pernyataan Pemasangan Tanda Batas dan Persetujuan Pemilik Yang Berbatasan",
                    note: "Wajib diisi secara lengkap dan sudah ditandatangani pemohon",
                  },
                ].map((row) => (
                  <tr key={row.no}>
                    <td style={{ textAlign: "center", border: "1px solid" }}>{row.no}</td>
                    <td style={{ border: "1px solid" }}>{row.item}</td>
                    <td style={{ textAlign: "center", border: "1px solid" }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center", border: "1px solid" }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center", border: "1px solid" }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center", border: "1px solid" }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ border: "1px solid" }}>{row.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* === FOOTER TABLE: KETERANGAN & PEMERIKSA === */}
            <table
              border="1"
              cellPadding="8"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "10px",
              }}
            >
              <tbody style={{ fontStyle: "italic" }}>
                <tr>
                  <td style={{ width: "285px", border: "1px solid" }}>
                    <div style={{ height: "80px" }}>Keterangan</div>
                  </td>
                  <td style={{ border: "1px solid" }}>
                    <label>
                      <input type="checkbox" /> Lengkap, berkas bisa diproses
                    </label>
                  </td>
                  <td style={{ border: "1px solid" }}>
                    <label>
                      <input type="checkbox" /> Tidak Lengkap, berkas tidak dapat diproses
                    </label>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "285px", border: "1px solid" }}>
                    <div>Diperiksa Tanggal:</div>
                  </td>
                  <td style={{ border: "1px solid" }}></td>
                  <td style={{ border: "1px solid" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "285px", border: "1px solid" }}>
                    <div>Petugas Pemeriksa:</div>
                  </td>
                  <td style={{ border: "1px solid" }}></td>
                  <td style={{ border: "1px solid" }}>
                    <div>Paraf</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                textDecoration: "underline",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              <div>SURAT PERMOHONAN PENGUKURAN BIDANG TANAH</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div>Kepada</div>
              <div>Yth. Kepala Kantor Pertanahan Kabupaten Bogor I</div>
              <div>di -</div>
              <div>Tempat</div>
            </div>
            <div style={{ marginTop: "20px" }}>
              <div>Dengan hormat,</div>
              <div>Saya yang bertanda tangan di bawah ini:</div>

              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.nama_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>NIK</td>
                    <td>:</td>
                    <td>{validValue(item?.ktp_pemohon)}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>Alamat</td>
                    <td style={{ verticalAlign: "top" }}>:</td>
                    <td>{validValue(item?.alamat_pemohon)}</td>
                  </tr>

                  <tr>
                    <td>Nomor WhatsApp</td>
                    <td>:</td>
                    <td>{validValue(item?.telpon_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>:</td>
                    <td>{validValue(item?.email_pemohon)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: "15px" }}>Dengan ini mengajukan permohonan pengukuran bidang tanah untuk kegiatan sebagai berikut:</div>
            <ol style={{ paddingLeft: "0px", lineHeight: "1", marginTop: "5px", listStyle: "none" }}>
              <li>
                <label>
                  <input type="checkbox" /> Pengukuran Pertama Kali
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Pemecahan Bidang Tanah
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Penggabungan Bidang Tanah
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Pengukuran Ulang
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> Pengembalian Batas
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" /> ................
                </label>
              </li>
            </ol>

            <div style={{ marginTop: "15px" }}>Adapun lokasi bidang tanah yang dimohonkan pengukurannya terletak di:</div>
            <div>
              Desa {validValue(item?.desa)}, Kecamatan {validValue(item?.kecamatan)}, Kabupaten {validValue(item?.kabupaten)}, Provinsi {validValue(item?.propinsi)}
            </div>

            <div style={{ marginTop: "15px" }}>Sebagai kelengkapan permohonan ini, Saya lampirkan:</div>

            <ol type="a" style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
              <li>Surat permohonan pengukuran ini beserta alamat e-mail dan/atau nomor telepon aktif;</li>
              <li>Foto copy KTP;</li>
              <li>Print screen (cuplikan) lokasi bidang tanah yang dimohonkan (hasil share location);</li>
              <li>Surat Pernyataan Penutupan Berkas Permohonan dan Tidak Menuntut Pengembalian PNBP;</li>
              <li>Surat Pernyataan Pemasangan Tanda Batas dan Persetujuan Pemilik Yang Berbatasan.</li>
            </ol>
            <div style={{ marginTop: "15px" }}>&nbsp;&nbsp;&nbsp;&nbsp;Dengan ini Saya menyatakan bahwa Saya bersedia menerima hasil pengukuran yang dilakukan oleh petugas Kantor Pertanahan. Apabila terdapat perbedaan luas, baik berupa kekurangan maupun kelebihan dari data sebelumnya, Saya bersedia menerima hasil tersebut dan tidak akan mengajukan tuntutan dalam bentuk apapun terkait perbedaan luas yang terjadi.</div>
            <div style={{ marginTop: "40px" }}>
              <div style={{ textAlign: "center" }}>
                <div>Bogor, {validValue(item?.tanggal)} Hormat Saya,</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>({validValue(item?.nama_pemohon)})</div>
              </div>
            </div>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                textDecoration: "underline",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              <div>SURAT PERNYATAAN</div>
              <div>PENUTUPAN BERKAS PERMOHONAN DAN TIDAK MENUNTUT</div>
              <div>PENGEMBALIAN PNBP</div>
            </div>
            <div style={{ marginTop: "15px" }}>
              <div>SYang bertanda tangan di bawah ini:</div>

              <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                    <td style={{ width: "15px" }}>:</td>
                    <td>{validValue(item?.nama_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>NIK</td>
                    <td>:</td>
                    <td>{validValue(item?.ktp_pemohon)}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>Alamat</td>
                    <td style={{ verticalAlign: "top" }}>:</td>
                    <td>{validValue(item?.alamat_pemohon)}</td>
                  </tr>

                  <tr>
                    <td>Nomor WhatsApp</td>
                    <td>:</td>
                    <td>{validValue(item?.telpon_pemohon)}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>:</td>
                    <td>{validValue(item?.email_pemohon)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: "15px" }}>Dengan ini menyatakan bahwa:</div>

            <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
              <li>
                Saya menyetujui penutupan berkas permohonan pengukuran / penerbitan peta bidang tanah dan tidak menuntut pengembalian atas pembayaran PNBP (Penerimaan Negara Bukan Pajak), apabila :
                <ol type="a" style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
                  <li>Salah lokasi share location/tautan lokasi bidang tanah yang dimohon dalam radius 100 m.</li>
                  <li>
                    Pengukuran tidak dapat dilaksanakan karena:
                    <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px", listStyle: "none" }}>
                      <li>- Patok permanen tidak ada;</li>
                      <li>- Pemohon tidak hadir pada waktu yang telah dipilih;</li>
                      <li>- Situasi di lokasi tidak kondusif, misal terdapat penolakan dari pihak lain;</li>
                      <li>- Sengketa batas/kepemilikan.</li>
                    </ol>
                  </li>
                  <li>
                    Setelah dilakukan pengolahan, Peta Bidang Tanah (PBT) tidak dapat diterbitkan karena tumpang tindih dengan:{" "}
                    <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px", listStyle: "none" }}>
                      <li>- Bidang tanah yang sudah terdaftar;</li>
                      <li>- Kawasan hutan;</li>
                      <li>- Kawasan perairan.</li>
                    </ol>
                  </li>
                  <li>Surat Pernyataan Penutupan Berkas Permohonan dan Tidak Menuntut Pengembalian PNBP;</li>
                  <li>Surat Pernyataan Pemasangan Tanda Batas dan Persetujuan Pemilik Yang Berbatasan.</li>
                </ol>
              </li>
              <li>Peta Bidang Tanah dinyatakan batal dengan sendirinya apabila di kemudian hari diketahui bahwa tanah yang dimohon tumpang tindih dan/atau merupakan aset Pemerintah, Badan Usaha Milik Negara (BUMN), atau Badan Usaha Milik Daerah (BUMD).</li>
            </ol>
            <div style={{ marginTop: "15px" }}>Demikian surat pernyataan ini Saya buat dengan sebenar-benarnya dalam keadaan sadar, tanpa adanya paksaan dari pihak manapun.</div>
            <div style={{ marginTop: "40px" }}>
              <div style={{ textAlign: "center" }}>
                <div>Bogor, {validValue(item?.tanggal)} Hormat Saya,</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>({validValue(item?.nama_pemohon)})</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {type === "print-sk-penetapan" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
            <div style={{ width: "20px" }}>B.</div>
            <div>MENGENAI TANAH YANG DIMOHON</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>1.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Letaknya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "120px" }}>Jalan</td>
                        <td style={{ width: "20px" }}>:</td>
                        <td>{validValue(item?.jalan)}</td>
                      </tr>
                      <tr>
                        <td>Kelurahan/Desa</td>
                        <td>:</td>
                        <td>{validValue(item?.desa)}</td>
                      </tr>
                      <tr>
                        <td>Kecamatan</td>
                        <td>:</td>
                        <td>{validValue(item?.kecamatan)}</td>
                      </tr>
                      <tr>
                        <td>Kabupaten</td>
                        <td>:</td>
                        <td>{validValue(item?.kabupaten)}</td>
                      </tr>
                      <tr>
                        <td>Provinsi</td>
                        <td>:</td>
                        <td>{validValue(item?.propinsi)}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>2.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Luasnya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <div>{validValue(item?.luas)} M²</div>
                  <div>Peta Bidang Tanah</div>
                  {/* <div>Tgl.19/09/2025 No.1726/2025</div> */}
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>3.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Batas-batas</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "120px" }}>Utara</td>
                        <td style={{ width: "20px" }}>:</td>
                        <td>{validValue(item?.utara)}</td>
                      </tr>
                      <tr>
                        <td>Timur</td>
                        <td>:</td>
                        <td>{validValue(item?.timur)}</td>
                      </tr>
                      <tr>
                        <td>Selatan</td>
                        <td>:</td>
                        <td>{validValue(item?.selatan)}</td>
                      </tr>
                      <tr>
                        <td>Barat</td>
                        <td>:</td>
                        <td>{validValue(item?.barat)}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>4.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Statusnya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <div>{validValue(item?.status_tanah)}</div>
                  <div>
                    Hak {validValue(item?.hak)} Adat {validValue(item?.adat)}
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>5.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Jenis dan Keadaan Tanah</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>{validValue(item?.jenis_tanah)}</td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>6.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Dasar Penguasaan (Siapa Yang Menguasai Sekarang Kalau Permohonan, apa Dasarnya sebutkan tanggal/Nomor Aktenya secara berurutan)</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <div>{validValue(item?.dasar_penguasaan)}</div>
                  {/* <div>500.17.2.1/058,/059,/057,/052,/041,/039,/042,/040,/051,/048/SPPH.KLP/2025</div> */}
                </td>
              </tr>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>7.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Rencana Penggunaanya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>{validValue(item?.digunakan_tanah)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px", display: "flex", alignItems: "center", fontWeight: "bold" }}>
            <div style={{ width: "20px" }}>C.</div>
            <div>TANAH LAIN YANG DI PUNYAI</div>
          </div>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "220px", verticalAlign: "top", fontWeight: "bold", textDecoration: "underline" }}>SIPEMOHON</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td>
                  <div>1. -</div>
                  <div>{validValue(item?.kabupaten)}</div>
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>(Sebutkan status tanah, luas, dan letaknya Dengan menunjuk Kabupaten/kotamadya saja)</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>
                  <div>2. -</div>
                  <div>3. -</div>
                  <div>4. -</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px", display: "flex", alignItems: "center", fontWeight: "bold" }}>
            <div style={{ width: "20px" }}>D.</div>
            <div>SURAT-SURAT YANG DILAMPIRKAN</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1.5" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>1.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Foto copy KTP/Surat bukti Kewarganegaraan Indonesia/Surat Bukti Identitas Lainnya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td style={{ verticalAlign: "top" }}>Terlampir</td>
              </tr>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>2.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Foto copy akta atau Peraturan Pendirian Badan Hukum dan Pengesahannya</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td style={{ verticalAlign: "top" }}>Terlampir</td>
              </tr>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>3.</td>
                <td style={{ width: "200px", verticalAlign: "top" }}>Sertifikat Girik Surat Kavling. Surat-surat Bukti Pelepasan Hak dan Pelunasan Tanah dan Rumah yang telah dibeli dari</td>
                <td style={{ width: "10px", verticalAlign: "top" }}>:</td>
                <td style={{ verticalAlign: "top" }}>Terlampir</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
